var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import Styles from './button-back-styles.scss';
import { IconArrowBack } from '@/presentation/components/icons';
import React from 'react';
import { ButtonKVBase } from '@/presentation/components';
const ButtonBack = (_a) => {
    var { onClick, disabled } = _a, props = __rest(_a, ["onClick", "disabled"]);
    return (React.createElement("div", { className: Styles.wrapper },
        React.createElement(ButtonKVBase, Object.assign({ type: 'button', onClick: onClick, className: Styles.submitButton, disabled: disabled }, props),
            React.createElement("div", { className: Styles.buttonContent },
                React.createElement("div", { className: Styles.icon },
                    React.createElement(IconArrowBack, { color: "#000000" })),
                React.createElement("div", { className: Styles.text }, "Back")))));
};
export default ButtonBack;
